import React, { FC, useEffect } from 'react';
import { useParams } from 'react-router';

import { AppLayoutTop } from 'components/appComponents';

import { useGetDriverMixerAdjustmentsInfoQuery } from 'bus/driverMixerAdjustments/servisec';
import { DriverMixerAdjustmentsInfoItem } from 'bus/driverMixerAdjustments/types';

import { BlockAdjustmentInfo, BlockAdjustmentTable } from './components';

const DriverMixerAdjustmentsDetail: FC = () => {
  const { id } = useParams<{ id: string }>();

  const {
    data: form = {
      comment: '',
      date: '',
      driverName: '',
      sum: 0,
    } as DriverMixerAdjustmentsInfoItem,
    refetch: getDriverMixerAdjustmentsInfo,
  } = useGetDriverMixerAdjustmentsInfoQuery({ id });

  useEffect(() => {
    getDriverMixerAdjustmentsInfo();
  }, [getDriverMixerAdjustmentsInfo]);

  return (
    <div>
      <AppLayoutTop title="Корректировка зарплат" />
      <BlockAdjustmentInfo form={form} />
      <BlockAdjustmentTable adjustmentId={id} refreshDetail={getDriverMixerAdjustmentsInfo} />
    </div>
  );
};

export default DriverMixerAdjustmentsDetail;
